import { defineNuxtPlugin } from '#app';

import { AUTH_BROADCAST_CHANNEL } from '~/constants/auth';
import { createAccountSwitchFollower } from '~/utils/accountSwitchTabs';

type AccountSwitchFollower = ReturnType<typeof createAccountSwitchFollower>;

/**
 * Follows other tabs' account switches from the moment the GraphQL client exists, so a tab that is
 * still booting holds its first requests for a switch already under way.
 */
export default defineNuxtPlugin({
  name: 'account-switch-follower',
  dependsOn: ['urql'],
  setup(nuxtApp) {
    const channel = typeof BroadcastChannel === 'undefined' ? undefined : new BroadcastChannel(AUTH_BROADCAST_CHANNEL);
    const accountSwitchFollower = createAccountSwitchFollower({
      gate: nuxtApp.$operationGate,
      answer: message => channel?.postMessage(message),
    });

    if (channel) {
      channel.onmessage = event => accountSwitchFollower.handle(event.data);
    }

    return { provide: { accountSwitchFollower } };
  },
});

declare module '#app' {
  interface NuxtApp {
    $accountSwitchFollower: AccountSwitchFollower;
  }
}
